import {
  FaBalanceScale,
  FaBroadcastTower,
  FaDesktop,
  FaFileImport,
  FaLayerGroup,
  FaQrcode,
  FaTrophy,
  FaUsers,
} from "react-icons/fa";

export const TOURNAMENT_DEMO_URL =
  "https://www.scoreboard-judo-club.fr/";

export const TOURNAMENT_PHONE =
  "0680727707";

export const TOURNAMENT_PHONE_LABEL =
  "06.80.72.77.07";

export const TOURNAMENT_HERO_SLIDES = [
  {
    id: "tournoi-presentation",
    src: "/images/Tournoi01.jpg",
    alt: "Organisation d’un tournoi de judo avec MonAppliTournoi",
    eyebrow: "Organisation centralisée",
    title: "Préparez votre tournoi",
    highlight: "plus simplement",
    description:
      "Centralisez les inscriptions, les pesées, les répartitions, les combats et les résultats depuis une interface unique.",
  },
  {
    id: "tournoi-combats",
    src: "/images/Tournoi02.jpg",
    alt: "Gestion des combats avec MonAppliTournoi",
    eyebrow: "Suivi en temps réel",
    title: "Pilotez les combats",
    highlight: "tapis par tapis",
    description:
      "Les tables suivent les combats en direct, saisissent les résultats et alimentent automatiquement les poules et les classements.",
  },
  {
    id: "tournoi-scoreboard",
    src: "/images/MACTournoi/07.png",
    alt: "Tableau de score intégré à MonAppliTournoi",
    eyebrow: "Scoreboard intégré",
    title: "Diffusez les scores",
    highlight: "sur un second écran",
    description:
      "Utilisez le tableau de score depuis la table d’arbitrage et affichez simultanément les informations utiles au public.",
  },
];

export const TOURNAMENT_HERO_BADGES = [
  "Sans installation",
  "Compatible PC, tablette et mobile",
  "Résultats publics en direct",
  "Accompagnement personnalisé",
];

export const TOURNAMENT_HERO_STATS = [
  {
    icon: FaUsers,
    label: "Clubs invités",
    value: "Inscriptions",
    description:
      "Formulaire dédié ou import Excel des compétiteurs.",
  },
  {
    icon: FaLayerGroup,
    label: "Répartitions",
    value: "Poules & tableaux",
    description:
      "Organisation automatique selon les catégories.",
  },
  {
    icon: FaBroadcastTower,
    label: "Compétition",
    value: "Résultats en direct",
    description:
      "Suivi accessible aux coachs et au public.",
  },
];

export const TOURNAMENT_QUICK_LINKS = [
  {
    id: "tournoi-about",
    label: "Fonctionnalités",
  },
  {
    id: "tournoi-pages",
    label: "Aperçus",
  },
  {
    id: "tournoi-contact",
    label: "Démonstration",
  },
];

export const TOURNAMENT_KEY_FEATURES = [
  {
    icon: FaFileImport,
    title: "Import des compétiteurs",
    description:
      "Importez rapidement les fichiers issus de l’Extranet ou saisissez les participants manuellement.",
  },
  {
    icon: FaBalanceScale,
    title: "Pesées et présences",
    description:
      "Contrôlez les présents, les poids et les catégories avant la génération des répartitions.",
  },
  {
    icon: FaLayerGroup,
    title: "Poules et tableaux",
    description:
      "Créez des poules ou des tableaux adaptés au nombre de combattants et au format du tournoi.",
  },
  {
    icon: FaDesktop,
    title: "Tables d’arbitrage",
    description:
      "Suivez les combats, renseignez les scores et désignez automatiquement les vainqueurs.",
  },
  {
    icon: FaQrcode,
    title: "Accès public par QR code",
    description:
      "Permettez aux coachs et au public de consulter l’avancement et les résultats.",
  },
  {
    icon: FaTrophy,
    title: "Résultats et podiums",
    description:
      "Publiez les classements, statistiques, podiums et photos à la fin de la compétition.",
  },
];